import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { FractionalSection } from "@/components/sections/FractionalSection";
import { CTASection } from "@/components/sections/CTASection";
import { SEO } from "@/components/SEO";

const Fractional = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Fractional Leadership | It's All About Growth"
        description="Senior fractional growth and marketing leadership without the cost or ramp time of a full-time CMO. Embedded operating partners on every engagement."
        path="/fractional"
      />
      <Header />
      <main className="pt-20">
        <FractionalSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Fractional;
